import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_GRANT + actions.FULFILLED:
            return fromJS(action.payload);

        case actions.SET_GRANT_FIELD:
            return state.withMutations(mut => {
                return mut
                    .set(action.field, action.payload)
                    .set('sessionId', action.currentSessionId);
            });
           
        case actions.NEW_GRANT:
            return getInitialState();


        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({
        isActive: true,
        startDate: new Date(),
        endDate: new Date()
    });
};